<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="d-flex py-2">
			<div>
				<el-select v-model="ser.cxnum" placeholder="请选择" size="mini">
				    <el-option v-for="item in cxlist" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</div>
			<div class="ml-2">
				<el-select v-model="ser.mxnum" placeholder="请选择" size="mini">
				    <el-option v-for="item in mxlist" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</div>
			<div class="ml-2">
				<el-date-picker v-model="ser.daynum" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
			</div>
			<div class="ml-2">
				<el-button type="primary" @click="onSubmit" size="mini">查询报表</el-button>
			</div>
			<div class="ml-2">
				<el-button type="primary" @click="printData" size="mini">打印报表</el-button>
			</div>
		</div>
		
		<el-table :data="list" style="width: 100%;" size="mini" key="table1" :max-height="maxHeight" v-if="ser.mxnum == 0">
			<el-table-column align="center" prop="day" width="100" label="应收日期" ></el-table-column>
			<el-table-column align="center" prop="zje" width="100" label="应收金额" ></el-table-column>
			<el-table-column align="center" prop="wx_money" width="100" label="微信" ></el-table-column>
			<el-table-column align="center" prop="money" width="100" label="现金" ></el-table-column>
			<el-table-column align="center" prop="ds_money" width="100" label="待收" ></el-table-column>
		</el-table>
		
		<el-table :data="list" style="width: 100%;" size="mini" key="table1" :max-height="maxHeight" v-else>
			<el-table-column align="center" prop="day" width="100" label="客户简称" >
				<template slot-scope="scope">
					<div class="">{{scope.row.khdata.j_name}}</div>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="day" width="100" label="客户名称" >
				<template slot-scope="scope">
					<div class="">{{scope.row.khdata.name}}</div>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="bh" width="100" label="应收单号" ></el-table-column>
			<el-table-column align="center" prop="day" width="100" label="应收日期" ></el-table-column>
			<el-table-column align="center" prop="zje" width="100" label="应收金额" ></el-table-column>
			<el-table-column align="center" prop="zf_time" width="200" label="付款日期" ></el-table-column>
		</el-table>
		
		<!-- 打印模板 -->
		<div class="print-div none" id="print_area" media="print">
			<div v-if="ser.mxnum == 0">
				<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
					<div style="width: 40%;">打印日期{{day}}</div>
					<div style="width: 40%;font-size: 24px;">应收报表</div>
					<div style="width: 20%;"></div>
				</div> 
				<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;">
					<div style="width: 20%;display: flex;justify-content: center; align-items: center;margin-top: 4px;margin-bottom: 4px;">应收日期</div>
					<div style="width: 20%;display: flex;justify-content: center; align-items: center;">应收金额</div>
					<div style="width: 20%;display: flex;justify-content: center; align-items: center;">微信</div>
					<div style="width: 20%;display: flex;justify-content: center; align-items: center;">现金</div>
					<div style="width: 20%;display: flex;justify-content: center; align-items: center;">待收</div>
				</div>
				<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;" v-for="item in list">
					<div style="width: 20%;display: flex;justify-content: center; align-items: center;margin-top: 4px;margin-bottom: 4px">{{item.day}}</div>
					<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.zje}}</div>
					<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.wx_money}}</div>
					<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.money}}</div>
					<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.ds_money}}</div>
				</div>
				<div style="width: 100%;display: flex;">
					<div style="width: 20%;display: flex;justify-content: center; align-items: center;margin-top: 4px;margin-bottom: 4px">汇总</div>
					<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{hzje}}</div>
					<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{hzwx}}</div>
					<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{hzxj}}</div>
					<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{hzds}}</div>
				</div>
			</div>
			<div v-else>
				<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
					<div style="width: 40%;">打印日期{{day}}</div>
					<div style="width: 40%;font-size: 24px;">应收明细报表</div>
					<div style="width: 20%;"></div>
				</div> 
				<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;">
					<div style="width: 10%;display: flex;justify-content: center; align-items: center;margin-top: 4px;margin-bottom: 4px;">客户简称</div>
					<div style="width: 14%;display: flex;justify-content: center; align-items: center;">客户名称</div>
					<div style="width: 14%;display: flex;justify-content: center; align-items: center;">应收单号</div>
					<div style="width: 18%;display: flex;justify-content: center; align-items: center;">应收日期</div>
					<div style="width: 18%;display: flex;justify-content: center; align-items: center;">应收金额</div>
					<div style="width: 26%;display: flex;justify-content: center; align-items: center;">付款日期</div>
				</div>
				<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;" v-for="item in list">
					<div style="width: 10%;display: flex;justify-content: center; align-items: center;margin-top: 4px;margin-bottom: 4px">{{item.khdata.j_name}}</div>
					<div style="width: 14%;display: flex;justify-content: center; align-items: center;">{{item.khdata.name}}</div>
					<div style="width: 14%;display: flex;justify-content: center; align-items: center;">{{item.bh}}</div>
					<div style="width: 18%;display: flex;justify-content: center; align-items: center;">{{item.day}}</div>
					<div style="width: 18%;display: flex;justify-content: center; align-items: center;">{{item.zje}}</div>
					<div style="width: 26%;display: flex;justify-content: center; align-items: center;">{{item.zf_time}}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import { mapState } from 'vuex';
export default {
	mixins: [common],
	inject: ['layout'],
	components: {
		buttonSearch
	},
	data() {
		return {
			ser: {
				cxnum:0,
				mxnum:0,
				daynum:''
			},
			cxlist: [
				{
					value: 0,
					label: '按应收日期'
				},{
					value: 1,
					label: '按收款日期'
				},
			],
			mxlist: [
				{
					value: 0,
					label: '汇总'
				},{
					value: 1,
					label: '明细'
				},
			],
			list:[],
			hzje:0,
			hzwx:0,
			hzxj:0,
			hzds:0,
			maxHeight:500,
			day:''
		};
	},
	// 计算属性
	computed: {
		// 引入store-modules的user模块里面的user(存储用户相关的数据)
		...mapState({
			user: state => state.user.user
		}),
		
	},
	mounted() {
		    // 获取当前时间
		    const today = new Date();
		    // 获取当前时间(today)的年份
		    const year = today.getFullYear();
		    // 获取月份
		    const month = String(today.getMonth() + 1).padStart(2, '0');
		    // 获取当前日
		    const day = String(today.getDate()).padStart(2, '0');
		    // 得到年月日
		    this.day = `${year}-${month}-${day}`; //打印当前日期
	},
	methods: {
			
		onSubmit(){
			this.axios.post('/admin/bb/yfbb',this.ser, { token: true }).then(res => {
				this.list = res.data.data
				console.log(this.list)
			});
		},
		printData(){
			this.list
			this.hzje = 0
			this.hzwx = 0
			this.hzxj = 0
			this.hzds = 0
			for(let i of this.list){
				this.hzje += parseFloat(i.zje)
				this.hzwx += parseFloat(i.wx_money)
				this.hzxj += parseFloat(i.money)
				this.hzds += parseFloat(i.ds_money)
			}
			this.hzje.toFixed(2)
			this.hzwx.toFixed(2)
			this.hzxj.toFixed(2)
			this.hzds.toFixed(2)
			setTimeout(()=> {
				const style = '@page {  } ' +'@media print { .print-div{ padding:8px;background-color:#cccccc; }' ;
				printJS({
					printable: 'print_area',
					type: 'html',
					style: style,// 亦可使用引入的外部css;
					scanStyles: false
				})
				this.value = '更多'
			}, 1000);
		},
	}
};
</script>

<style>
.el-collapse-item__header {
	/* display: flex; */
	align-items: center;
	height: 48px;
	line-height: 48px;
	margin-left: 10px;
	cursor: pointer;
	font-size: 13px;
	/* font-weight: 500; */
	transition: border-bottom-color 0.3s;
	outline: 0;
}
.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
.el-dropdown-link {
	cursor: pointer;
	color: #ff8c00;
}
.el-icon-arrow-down {
	font-size: 12px;
}
</style>
